"use client";

import { c as _c } from "react/compiler-runtime";
import { GoogleTagManager } from "@shared/lib/scripts/gtm";
import { LANDING_LOCALE_STORAGE_KEY, LANDING_URL_STORAGE_KEY } from "@shared/utils";
import { useEffect } from "react";
export function ClientInit(t0) {
  const $ = _c(6);
  const {
    gtmId,
    locale
  } = t0;
  let t1;
  let t2;
  if ($[0] !== gtmId) {
    t1 = () => {
      GoogleTagManager.init({
        id: gtmId
      });
      localStorage.setItem(LANDING_URL_STORAGE_KEY, window.location.href);
    };
    t2 = [gtmId];
    $[0] = gtmId;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[3] !== locale) {
    t3 = () => {
      const map = {
        "id-ID": "id",
        en: "en"
      };
      localStorage.setItem(LANDING_LOCALE_STORAGE_KEY, map[locale] ?? "en");
    };
    t4 = [locale];
    $[3] = locale;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  useEffect(t3, t4);
  return null;
}